"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStoryAndMission() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="19629" id="rooted-in-freetown" ref={sectionRef} className="relative w-full py-20 lg:py-32 dark bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-secondary/10 rounded-full blur-3xl opacity-40 mix-blend-screen" />
        <div className="absolute bottom-1/4 -right-20 w-[30rem] h-[30rem] bg-primary/10 rounded-full blur-3xl opacity-30 mix-blend-screen" />
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className={`relative transition-all duration-1000 ease-out delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            {}
            <div className="absolute top-10 left-4 w-3/4 h-3/4 bg-accent/10 rounded-[3rem] -z-10 transform -rotate-6" />

            <div className="relative pr-12 pb-12">
              {}
              <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl shadow-black/40 aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 transform rotate-2 border-8 border-white dark:border-card">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/carewell_interior_vertical_hallway.png" alt="The welcoming and modern hallway of Freetown Family Clinic" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" />
              </div>

              {}
              <div className="absolute bottom-0 right-0 z-20 w-3/5 rounded-xl overflow-hidden shadow-2xl border-8 border-white dark:border-card transform -rotate-3">
                <div className="aspect-[4/3]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612706/img/carewell_doctor_patient_consult_horizontal.png" alt="A compassionate consultation between our physician and a local resident" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" />
                </div>
              </div>
              
              {}
              <div className="absolute top-1/2 right-10 w-4 h-4 bg-secondary rounded-full blur-sm z-30 animate-pulse" />
            </div>
          </div>

          {}
          <div className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <span className="inline-block text-secondary font-mono tracking-widest text-xs uppercase bg-secondary/10 px-4 py-1.5 rounded-full border border-secondary/20">
                Our Heritage
              </span>
              
              <h2 className="text-5xl lg:text-6xl font-serif text-foreground leading-tight tracking-tight">
                Deeply Rooted in Compassionate Care
              </h2>
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed font-sans">
              <p>
                Freetown Family Clinic began as a small neighborhood practice with a big vision: to provide every family in our community with the quality care they deserve. From our early days serving local families to becoming a trusted healthcare organization, our commitment to compassionate, personalized medicine has never wavered. We are more than a clinic; we are your neighbors.
              </p>
            </div>

            {}
            <div className="py-2">
              <span className="font-serif text-3xl text-secondary italic opacity-80 select-none transform -rotate-1 inline-block">
                Freetown Family Clinic
              </span>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-full px-10 h-14 text-base font-medium shadow-xl shadow-primary/20 bg-gradient-to-r from-primary to-primary/80 hover:shadow-primary/40 transition-all duration-300 border-none">
                <Link to="/OurTeamPage" aria-label="Meet our dedicated medical team">
                  Meet Our Team
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}